import styled from 'styled-components';

export const H1 = styled.h1`
    text-align: center;
    font-size: 25rem;
    /* color: ${(props) => props.theme.fontColorPrimary}; */
`;

export const P = styled.p`
    text-align: center;
    font-size: 2rem;
    color: ${(props) => props.theme.fontColorSecondary};
`;
